// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactNavBar-cls1_dph","cls2":"ImpactNavBar-cls2_b3f ImpactNavBar-cls1_dph"};